import { render } from "./NavbarContacList.vue?vue&type=template&id=a7b1c17e"
import script from "./NavbarContacList.vue?vue&type=script&lang=js"
export * from "./NavbarContacList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__